import Api from '@/services/Api';

export default {
  login(creds) { return Api().post('login', creds); },
  loginUser(creds) { return Api().post('loginUser', creds); },
  pwl(creds) { return Api().post('pwl', creds); },
};
